exports = module.exports = require("../../../../../../../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".theme--light.v-sheet--outlined{border:thin solid rgba(0,0,0,.12)}", ""]);

// exports
